import React from 'react';
import { useTranslation } from 'react-i18next';

const PARTNERS = [
  { id: 1, name: 'Microsoft Data AI', logo: '/assets/pic/microsoft_data_ai_spec.jpg', width: 240, height: 120 },
  { id: 2, name: 'NVIDIA Inception', logo: '/assets/pic/nvidia-inception-program-badge-rgb-for-screen.jpg', width: 240, height: 120 },
  { id: 3, name: 'Center Q', logo: '/assets/pic/centerqcolor.jpg', width: 240, height: 120 },
  { id: 4, name: 'PT Logo', logo: '/assets/pic/pt-logo-b-2.png', width: 240, height: 80 },
  { id: 5, name: 'Group 43', logo: '/assets/pic/group-43.png', width: 240, height: 80 },
  { id: 6, name: 'Group', logo: '/assets/pic/group.png', width: 240, height: 80 },
  { id: 7, name: 'Logo EN', logo: '/assets/pic/logo_en-2-e1655656870347.png', width: 240, height: 80 },
  { id: 8, name: 'OG', logo: '/assets/pic/og-4c10bae940c8c3309fdc642f2d0776216c76d399bc0b935c6ed3fa019bfc4d98-e1655891755572-300x108-1.png', width: 300, height: 108 },
  { id: 9, name: 'Photo 1', logo: '/assets/pic/photo_2024-03-13_11-21-13.jpg', width: 240, height: 160 },
  { id: 10, name: 'Photo 2', logo: '/assets/pic/photo_2024-03-25_15-34-31.jpg', width: 240, height: 160 },
  { id: 11, name: 'Photo 3', logo: '/assets/pic/photo_2024-04-04_07-49-12.jpg', width: 240, height: 160 },
  { id: 12, name: 'Photo 4', logo: '/assets/pic/photo_2024-04-04_14-20-20-768x768.jpg', width: 240, height: 240 },
  { id: 13, name: 'Image 6142', logo: '/assets/pic/img_6142.png', width: 240, height: 120 },
  { id: 14, name: 'Google Cloud Support', logo: '/assets/pic/do-all-kind-of-google-cloud-support.jpg', width: 240, height: 160 },
  { id: 15, name: 'Logo', logo: '/assets/pic/6353c7b7ebc462e51df5c89fc0182839-300x300.jpg', width: 240, height: 240 }
];

const Partners = () => {
  const { t } = useTranslation();

  return (
    <section className="partners-section">
      <div className="container">
        <h2 className="section-title">{t('partners.title')}</h2>
        <p className="section-subtitle">{t('partners.description')}</p>
        <div className="partners-container">
        <ul className="partners-slider partners-slider--static">
          {PARTNERS.map((partner) => (
            <li key={partner.id} className="partner-item">
              <img
                src={partner.logo}
                alt={partner.name}
                title={partner.name}
                width={partner.width}
                height={partner.height}
                loading="lazy"
                decoding="async"
              />
            </li>
          ))}
        </ul>
      </div>
      </div>
    </section>
  );
};

export default Partners;
